<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
    <div class="conten">
      <div class="btn"><a>RCA Tree Settings</a></div>
    </div>
  </div>


  <div class="bg-default px-3 pb-3">
    <div class="grid">
      <!-- Search Filters start -->
      <div class="field md:col-2">
        <label for="FirstName"><b>Filter Type</b></label>
        <p-dropdown [options]="workFlow_typeOptions" [(ngModel)]="workFlowType"
          (onChange)="GetRCTreeDataOnFilter(FormType.value)" optionLabel="name" #FormType optionValue="value"
          class="mr-2">
        </p-dropdown>
      </div>
    </div>
    <div class="flex justify-content-center" *ngIf="_database.isAccessReadWrite">
      <button pButton type="button" icon="pi pi-plus" class="p-button-rounded p-button-outlined"
        (click)="showAddDialog('#')"></button>
    </div>

    <div class="grid">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <span class="mat-icon-button" disabled></span>
          <span>
            <span >{{node.item!='children'?node.item:[]}}</span>
            <Span class="rca-icons" *ngIf="_database.isAccessReadWrite">
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-plus hover-color" (click)="showAddDialog(node)"></i></a>
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-pencil hover-color" (click)="showEditDialog(node)"></i></a>
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-trash hover-color" (click)="deleteTreeNode(node)"></i></a>
            </Span>
          </span>
        </mat-tree-node>


        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <span class="mat-icon-button" matTreeNodeToggle [attr.aria-label]="'Toggle' + node.item">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node)? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </span>
          <span>
            <span >{{node.item!='children'?node.item:[]}}</span>
            <Span class="rca-icons" *ngIf="_database.isAccessReadWrite">
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-plus hover-color" (click)="showAddDialog(node)"></i></a>
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-pencil hover-color" (click)="showEditDialog(node)"></i></a>
              <a class="mr-4 cursor-pointer rca-icon"><i class="pi pi-trash hover-color" (click)="deleteTreeNode(node)"></i></a>
            </Span>
          </span>

        </mat-tree-node>
      </mat-tree>

    </div>
  </div>
  <p-dialog [(visible)]="addDisplay" [modal]="true" position="top"  [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      Add Data
    </ng-template>
    <form [formGroup]="addForm">
      <div class="grid p-fluid mt-3">
        <div class="col-6">
          <p-dropdown [options]="PatientDiagramOption" formControlName="PatientDiagram"
            placeholder="Select a Patient Diagram" optionLabel="label"></p-dropdown>
        </div>
        <div class="col-6">
          <p-dropdown [options]="nodeAvailable" formControlName="nodeAvailable" placeholder="Is this node Available"
            optionLabel="label"></p-dropdown>
        </div>
        <div class="col-3 mt-3">
          <span class="p-float-label">
            <input id="float-input-invalid" formControlName="text" type="text" pInputText class="p-inputtext-lg">
            <label for="float-input-invalid">Title</label>
          </span>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button pButton label="Save" [disabled]="!addForm.valid" (click)="saveAddNode()"></button>
    </ng-template>
  </p-dialog>


  <p-dialog [(visible)]="editDisplay" [modal]="true" position="top"  [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      Edit Data
    </ng-template>
    <form [formGroup]="editForm">
      <div class="grid p-fluid mt-3">
        <div class="col-6">
          <p-dropdown [options]="PatientDiagramOption" formControlName="editPatientDiagram"
            placeholder="Select a Patient Diagram" optionLabel="label" [showClear]="true"></p-dropdown>
        </div>
        <div class="col-6">
          <p-dropdown [options]="nodeAvailable" formControlName="editNodeAvailable" placeholder="Is this node Available"
            optionLabel="label" [showClear]="true"></p-dropdown>
        </div>
        <div class="col-3 mt-3">
          <span class="p-float-label">
            <input id="float-input-invalid" [(ngModel)]="editText" formControlName="text" type="text" pInputText
              class="p-inputtext-lg">
            <label for="float-input-invalid">Title</label>
          </span>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <button pButton label="Save" [disabled]="!editForm.valid" (click)="editNode()"></button>
    </ng-template>
  </p-dialog>


  

  <p-toast [style]="{width: '25vw',opacity:'1'}" position="center" key="c" (onClose)="onReject()">
    <p-toast key="DeleteContact" position="top-right"></p-toast>
    <ng-template let-message pTemplate="message">
      <div class="flex flex-column" style="flex: 1">
        <div class="text-center">
          <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
          <h4>{{message.summary}}</h4>
          <p>{{message.detail}}</p>
        </div>
        <div class="grid p-fluid">
          <div class="col-6">
            <p-button label="YES" class="ml-2 p-button-primary btn-padding-custom" (click)="onConfirm()" type="button">
            </p-button>
          </div>
          <div class="col-6">
            <p-button label="No" class="ml-2 p-button-secondary btn-padding-custom" (click)="onReject()" type="button">
            </p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>